import React, { useEffect, useState } from "react";
import { getDomainConfig } from "../../config/config";
import { useContent } from "../../hooks/useContent";
import { LogoPopUpMenu } from "../LogoPopUpMenu/LogoPopUpMenu";
import { HeaderPhoneUniversal } from "../HeaderPhoneUniversal/HeaderPhoneUniversal";
import { HeaderPhoneSw } from "../HeaderPhoneSw/HeaderPhoneSw";
import EmergencyBanner from "../EmergencyBanner/EmergencyBanner";
import { useSettings } from "../../hooks/useSettings";

const Header = () => {
  const config = getDomainConfig();

  /* LOADING THE BRANDED SCSS */
  const [styles, setStyles] = useState(false);
  const { data: settingsData } = useSettings();

  useEffect(() => {
    const getStyles = async (theFileName, theFileEnd) => {
      if (config.brand) {
        let moduleStyles = false;
        try {
          moduleStyles = await import(
            "./" + theFileName + config.brand + theFileEnd
          );
          setStyles(moduleStyles);
        } catch (e) {
          console.error(
            `Styles for ${theFileName} could not be loaded, ${e.message}`
          );
        }
      }
    };

    // Specify file name and end of file name here.
    getStyles("Header", ".module.scss");
  }, [config.brand]);

  /* END LOADING THE BRANDED SCSS */

  // Default vars.
  let phone = "";
  let openingHours = "";
  let gtmCode = "";

  // Get data from api config.
  const { isSuccess: contentIsSuccess, data: ContentData } = useContent();


  // Assign vars once loaded.
  if (contentIsSuccess) {
    phone = ContentData.phone;
    openingHours = ContentData.opening_hours;
    gtmCode = ContentData.gtm_account;
  }

  useEffect(() => {
    if (gtmCode) {
      const scriptTag = document.createElement("script");
      const noScriptTag = document.createElement("noscript");

      scriptTag.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
          j.src='https://wingate.attractiontickets.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmCode}');`;

      noScriptTag.innerHTML = `<iframe src="https://wingate.attractiontickets.com/ns.html?id=${gtmCode}"
                  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

      document.head.appendChild(scriptTag);
      document.body.prepend(noScriptTag);

      return () => {
        document.head.removeChild(scriptTag);
        document.body.removeChild(noScriptTag);
      };
    }
  }, [gtmCode]);

  return (
    <>
      {(settingsData?.emergency_banner && settingsData?.emergency_banner.enabled) && <EmergencyBanner text={settingsData.emergency_banner.text} />}
      <header className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={styles.logoHolder}>
          <a className={styles.logoImg} href="/">
            <img
              className={styles.logo}
              src={config.logo}
              alt={config.siteName}
            />
          </a>
          <LogoPopUpMenu />
        </div>
        <div className={styles.infoHolder}>
          {config.brand === "Uo" ? (
            <HeaderPhoneUniversal />
          ) : (
            <>
            {config.brand === "Sw" ? (
              <HeaderPhoneSw />
            ) : (
              <ul className={styles.siteLinks}>
              {phone && (
                <li className={styles.siteLink}>
                  <strong>{phone}</strong>
                </li>
              )}
              {openingHours && (
                <li className={styles.siteLink}>
                  <em>{openingHours}</em>
                </li>
              )}
            </ul>
            )}
            </>
          )}
        </div>
      </div>
      </header>
    </>

  );
};

export default Header;
